import { ABORTED_ERROR_STRING, onAbort } from './abort'

const timeout = 10_000
const TIMEOUT_ERROR_STRING = 'Error waiting for callback'

// Arms a timeout for a callback a provider promises to call. The returned function is called from
// that callback: it disarms the timeout and says whether the wait had already ended (timed out or
// aborted), in which case the callback's data is stale and must not be used.
export const waitForCallback = (reject: (error: string) => void, signal?: AbortSignal) => {
  let ended = false
  let stopListening = (): void => {}

  const id = setTimeout(() => {
    ended = true
    stopListening()
    reject(TIMEOUT_ERROR_STRING)
  }, timeout)

  stopListening = onAbort(signal, () => {
    ended = true
    clearTimeout(id)
    reject(ABORTED_ERROR_STRING)
  })

  return () => {
    clearTimeout(id)
    stopListening()
    return ended
  }
}
